/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const generateMagazineRowSettings = () => {
  let rowSettings = [
    { label: "Background Color", type: "colorPicker", keyName: "theme" },
    {
      label: "Subscribe Button",
      type: "checkbox",
      keyName: "showButton"
    },

    {
      label: "Button Text",
      type: "text",
      keyName: "buttonText"
    },

    {
      label: "Button Link",
      type: "text",
      keyName: "customUrlPath"
    }
  ];
  return { settings: rowSettings };
};
